// Modal component for displaying monthly transfers chart
// Shows detailed monthly growth data in a modal overlay

import React from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Box
} from "@chakra-ui/react";
import MonthlyTransfersChart from "./MonthlyTransfersChart";

const MonthlyTransfersModal = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="6xl">
            <ModalOverlay />
            <ModalContent maxW="90%" maxH="90vh">
                <ModalCloseButton 
                    position="absolute" 
                    left="8px" 
                    right="auto" 
                    top="8px" 
                    zIndex="3" 
                />
                <ModalHeader>
                    צמיחה חודשית - דוח מפורט
                </ModalHeader>
                <ModalBody pb={6}>
                    <Box h="500px">
                        <MonthlyTransfersChart />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default MonthlyTransfersModal;
